class Square {
    initialized = false;

    initialize(onSuccess: () => void, onFailure: () => void) {
        if (this.initialized || document.getElementById("square-js")) {
            console.warn("Square already initialized.");
            onSuccess();
            return;
        }

        if (!document) {
            console.warn("Square requires a document.");
            return;
        }

        const script = document.createElement("script");
        script.src = "https://web.squarecdn.com/v1/square.js";
        script.id = "square-js";
        script.onload = () => {
            this.initialized = true;
            onSuccess();
        };
        script.onerror = () => {
            onFailure();
        };

        document.head.insertBefore(script, document.head.childNodes[0]);

        this.initialized = true;
    }
}

export const square = new Square();
